import { useTranslation } from "@pancakeswap/localization";
import { useIsMounted } from "@pancakeswap/hooks";
import { PropsWithChildren, ReactNode } from "react";
import { AutoColumn, RowBetween, Text, TextProps, IconButton, PencilIcon } from "@pancakeswap/uikit";

type SwapInfoType = {
  price: ReactNode;
  allowedSlippage?: number;
  onSlippageClick?: () => void;
  allowedSlippageSlot?: React.ReactNode;
};

export const SwapInfoLabel = (props: PropsWithChildren<TextProps>) => (
  <Text fontSize="12px" bold color="secondary" {...props} />
);

export const SwapInfo = ({ allowedSlippage, price, onSlippageClick, allowedSlippageSlot }: SwapInfoType) => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();

  return (
    <AutoColumn gap="sm" py="0px" px="16px">
      <RowBetween alignItems="center">{price}</RowBetween>
      {typeof allowedSlippage === "number" && (
        <RowBetween style={{cursor: "pointer"}} alignItems="center">
          <SwapInfoLabel onClick={onSlippageClick}>
            {t("Slippage Tolerance")}
          </SwapInfoLabel>
          {isMounted &&
            (allowedSlippageSlot ?? (
              <Text bold color="primary" onClick={onSlippageClick}>
                {allowedSlippage / 100}%
              </Text>
            ))}
        </RowBetween>
      )}
    </AutoColumn>
  );
};
